exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sidebar-submenu[data-v-d2ef9d80] {\n  left: 0;\n  top: 0;\n  min-height: 100%;\n  transform: translateX(-100%);\n}\n.subcategory-item[data-v-d2ef9d80] {\n  display: flex;\n  width: 100%;\n}\n", ""]);

// exports
